<template>
    <ValidationObserver v-slot="{ invalid }">
        <v-card :class="{ jsCardHasError: invalid }">
            <v-card-title>
                <v-switch
                    v-model="published"
                    :label="publishedText"
                />
                <v-spacer />
                <v-radio-group
                    dense
                    v-model="level"
                    row
                >
                    <v-radio
                        label="Basic"
                        value="basic"
                        dense
                    />
                    <v-radio
                        label="Premium"
                        value="premium"
                        dense
                    />
                    <v-radio
                        label="Plus"
                        value="plus"
                        dense
                    />
                </v-radio-group>
            </v-card-title>
            <v-card-text>
                <form
                    action=""
                    method="POST"
                    @submit.prevent="save"
                >
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="name"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    id="name"
                                    v-model="name"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="order"
                                rules="integer"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Order"
                                    name="order"
                                    id="order"
                                    v-model="order"
                                    outlined
                                    :error-messages="errors[0]"
                                    type="number"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    v-if="stepId"
                    text
                    @click="toggleDeleteModal(true)"
                    :disabled="invalid || sections.length > 0"
                >
                    <span v-if="sections.length > 0 ">Remove attached sections to delete page</span>
                    <span v-else>Delete Step</span>
                </v-btn>
                <v-spacer />
                <v-btn
                    type="submit"
                    color="primary"
                    @click="save"
                >
                    <v-icon
                        left
                        small
                    >
                        fas fa-save
                    </v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</template>

<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import store from '../../../../store/store';

export default {
    computed: {
        name: {
            get: function() {
                return store.state.stepEditor.name;
            },
            set: function(value) {
                this.setName(value);
            }
        },

        order: {
            get: function() {
                return store.state.stepEditor.order;
            },
            set: function(value) {
                this.setOrder(value);
            }
        },

        published: {
            get: function() {
                return store.state.stepEditor.published;
            },
            set: function(value) {
                this.setPublished(value);
            }
        },

        level: {
            get: function() {
                return store.state.stepEditor.level;
            },
            set: function(value) {
                this.setLevel(value);
            }
        },

        ...mapState('stepEditor', ['stepId', 'sections']),

        ...mapGetters({
            publishedText: 'stepEditor/publishedText'
        })
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'stepEditor/getData',
            saveData: 'stepEditor/saveData'
        }),

        ...mapMutations({
            setId: 'stepEditor/setStepId',
            setName: 'stepEditor/setName',
            setOrder: 'stepEditor/setOrder',
            setPublished: 'stepEditor/setPublished',
            setLevel: 'stepEditor/setLevel',
            toggleDeleteModal: 'stepEditor/toggleDeleteModal'
        }),

        save() {
            this.saveData();
        }
    }
};
</script>
